// System
import React, { useMemo } from 'react';

// Components
import { TableBodyEx, TableContainerEx, TableEx } from '@Components/shared/tables/components';
import {
  ColumnVisibilityPresenter,
  TableHeadColumnsPresenter,
  TableHeadPresenter,
  TableRowPresenter,
} from '@Components/shared/tables/presenters';
import { LoadingScreen } from '@Components/shared/loaders/LoadingScreen';

// Utils
import { applyColumnVisibility } from '@utils/data/applyColumnVisibility';

//  Table
import { useTransactionExportsTableColumns } from './useTransactionExportsTableColumns';

// Redux
import { TransactionExportsDto } from '@contracts/api/dto/transaction/TransactionExportsDto';
import { useTransactionExportsTable } from '@Modal/hooks/transactionExports/useTransactionExportsTable';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useProviderExportsQuery } from '@Src/generated.graphql';

export const TransactionExportsTable: React.FC = () => {
  const { columnVisibility, visiblityCustomizable, transactionExportsListFilters } =
    useTransactionExportsTable();
  const { userPermissions, currentUser } = useAuthorization();
  const columns = useTransactionExportsTableColumns();

  const permissionToViewTransactionExports =
    userPermissions?.includes('CAN_VIEW_TRANSACTION_EXPORTS') || currentUser?.isSuper;

  const { data, loading } = useProviderExportsQuery({
    skip: !permissionToViewTransactionExports,
  });

  const visibleColumns = useMemo(
    () => applyColumnVisibility(columns, transactionExportsListFilters),
    [columns, columnVisibility]
  );

  const header = useMemo(
    () => (
      <TableHeadPresenter>
        <TableHeadColumnsPresenter columns={visibleColumns} />
        {/* @ts-ignore */}
        <ColumnVisibilityPresenter columns={columns} content={visiblityCustomizable} />
      </TableHeadPresenter>
    ),
    [columns]
  );

  if (!permissionToViewTransactionExports) return <h1>No Permission</h1>;
  if (loading) return <LoadingScreen />;

  if (data?.providerExports?.length === 0) {
    return <h1>No Data</h1>;
  }

  return (
    <>
      <TableContainerEx sx={{ height: '70vh' }}>
        <TableEx name="transactionExports">
          {header}
          <TableBodyEx>
            {/* @ts-ignore */}
            {data?.providerExports?.map((row: TransactionExportsDto) => (
              <TableRowPresenter
                id={row._id}
                key={row._id}
                columns={visibleColumns}
                row={row}
                onClick={() => {}}
              />
            ))}
          </TableBodyEx>
        </TableEx>
      </TableContainerEx>
    </>
  );
};
